//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import { getMoney } from '../../../../../../common/functions/helpers';
import informacoesContratoMixin from './informacoesContratoMixin';

export default {
  name: 'ApuracaoFinalizadaTabela',
  mixins: [informacoesContratoMixin],
  components: {
    Paginate,
  },
  props: {
    carregando: Boolean,
    apuracoes: Array,
    paginas: Number,
  },
  data() {
    return {
      indexPagina: 0,
      cabecalho: [
        this.$tc('label.acoes', 1),
        this.$t('label.numero_acordo'),
        this.$tc('label.cliente', 1),
        this.$t('label.acordo'),
        this.$t('label.tipo_acordo'),
        this.$tc('label.inicio_vigencia', 1),
        this.$tc('label.fim_vigencia', 1),
        this.$tc('label.representante', 1),
        this.$t('label.status'),
        this.$t('label.marca'),
        this.$t('label.linha_produto'),
        this.$t('label.familia'),
        this.$tc('label.produto', 1),
        this.$tc('label.pagamento', 1),
      ],
      status: 'AGUARDANDO_PAGAMENTO',
      listaStatus: [
        { status: 'AGUARDANDO_PAGAMENTO', descricao: this.$t('status_entidade.aguardando_pagamento') },
        { status: 'BLOQUEADO', descricao: this.$t('status_entidade.bloqueado') },
        { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
        { status: 'LIQUIDADO', descricao: this.$t('label.efetivado') },
      ],
    };
  },
  methods: {
    getMoney,
    classeCabecalho(index) {
      switch (index) {
        case 2: // cliente
        case 12: // produto
          return 'Tabela__LargeColumn';
        case 3: // acordo
        case 7: // representante
        case 8: // status
          return 'Tabela__BigColumn';
        case 4: // tipo acordo
        case 9: // marca
        case 10: // linha
        case 11: // familia
        case 13: // pagamento
          return 'Tabela__MediumColumn';
        default:
          return '';
      }
    },
    possuiRegistros() {
      return this.apuracoes.length !== 0;
    },
    filtraRegistros() {
      const paginaInicial = 0;
      this.$emit('APURACAO_FINALIZADA_TABELA_PAGINA', paginaInicial, this.status);
    },
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('APURACAO_FINALIZADA_TABELA_PAGINA', pagina);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
    statusApuracao(status) {
      return this.$tc(`status_entidade.${status.toLowerCase()}`, 1);
    },
    exibirSidebar(row) {
      const idMeta = row.idMeta;
      this.$emit('APURACAO_FINALIZADA_TABELA_EVIDENCIA', idMeta);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/ApuracaoFinalizadaTabela.vue?vue&type=script&lang=js&